import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
    // {
    //     path: '/',
    //     name: 'Landing',
    //     component: () => import(/* webpackChunkName: "environments" */ '../views/Landing.vue'),
    //     // component: Landing,
    //     props: {}
    // },
    {
        path: '/',
        name: 'Digitalplace',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "environments" */ '../views/DigitalPlace.vue')
    },
    {
        path: '/environments',
        name: 'Environments',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "environments" */ '../views/Environments.vue')
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
